import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type { OperatorResponse } from 'src/apis/contract-management/types';
import { isServerError, useAxios } from 'src/hooks/use-axios';

type HookConfig = {
  operatorUrl: string;
  operatorUuid: string;
};

type ExecuteProps = {
  operatorUuid: string;
};

export function useOperator({ operatorUrl, operatorUuid }: HookConfig) {
  const request = useAxios(
    (axios, baseConfig, { operatorUuid }: ExecuteProps) => {
      const url = urlTemplate
        .parse(operatorUrl)
        .expand({ operatorId: operatorUuid });

      return axios.request<OperatorResponse>({
        ...baseConfig,
        url,
      });
    },
    {
      neededOnPageLoad: true,
      onError: (err) => {
        if (isServerError(err, 404)) {
          return err;
        } else {
          throw err;
        }
      },
    }
  );

  useEffect(() => {
    request.execute({ operatorUuid });
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return request;
}

export type OperatorRequest = ReturnType<typeof useOperator>;
